'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var BOARD_ID_TRASH_APPEND = exports.BOARD_ID_TRASH_APPEND = '-trash';

var BOARD_SECTIONS = exports.BOARD_SECTIONS = {
    CANVAS: 'CANVAS',
    INBOX: 'INBOX',
    TRASH: 'TRASH'
};

var INBOX_STATE = exports.INBOX_STATE = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED'
};

var BOARD_TYPE = exports.BOARD_TYPE = 'BOARD';
var BOARD_DISPLAY_NAME = exports.BOARD_DISPLAY_NAME = 'Board';
var BOARD_DEFAULT_TITLE = exports.BOARD_DEFAULT_TITLE = 'New Board';

var DEFAULT_BOARD_WIDTH = exports.DEFAULT_BOARD_WIDTH = 10;


//////////////////
// WEBPACK FOOTER
// ./src/common/boards/boardConstants.js
// module id = 17
// module chunks = 0